/**
 * Routes:  and below
 *
 * Will me merged into the router's 'route' array
 */
import GesuchOverviewPanel from '@/views/auth/gesuch/Overview.vue'
import GesuchCreatePanel from '@/views/auth/gesuch/Create.vue'
import GesuchPanel from '@/views/auth/gesuch/GesuchPanel.vue'

export default [
    {
        path: '/gesuche',
        name: 'gesuche',
        component: GesuchOverviewPanel,
        meta: {
            requiresAuth: true,
            title: 'Gesuche',
        },
        children: [
            {
                path: 'erstellen',
                name: 'gesuch_erstellen',
                component: GesuchCreatePanel,
                meta: {
                    requiresAuth: true,
                    title: 'Gesuch erstellen',
                },
            },
            {
                path: ':nr',
                name: 'gesuch',
                component: GesuchPanel,
                meta: {
                    requiresAuth: true,
                    title: (to: { params: { nr: string } }) => to.params.nr,
                },
                children: [
                  {
                      path: ':step',
                      component: GesuchPanel,
                      name: 'gesuch-step',
                      meta: {
                          requiresAuth: true,
                          title: (to: { params: { nr: string } }) => to.params.nr,
                      },
                  },
                ]
            },
        ],
    },
]
